import {db, uuid} from "../Database.svelte";
import {readable} from "svelte/store";

export default class StockRecommendationModel {
    constructor (recommendation_id) {
        this.recommendation = db.get(recommendation_id)
    }

    static getStockRecommendationList() {
        let recommendation_list = [];

        return readable(undefined, (set) => {

            db.allDocs({
                include_docs: true,
                startkey: "stockRecommendation:",
                endKey: "stockRecommendation:\ufff0",
                type: "stockRecommendation"
            }).then((results) => {
                recommendation_list = results.rows.map(r => r.doc);
                set(recommendation_list)
            })

            let changeMonitor = db.changes({
                since: "now",
                live: true,
                include_docs: true,
                filter: "filters/doc_type",
                query_params: {
                    type: 'stockRecommendation'
                }
            }).on('change', (change) => {
                if (change.deleted) {
                    recommendation_list = recommendation_list.filter(rec => rec._id != change.id);
                } else {
                    let found = false;
                    recommendation_list = recommendation_list.map((rec) => {
                        if (rec._id != change.id) return rec;
                        found = true;
                        return change.doc;
                    });

                    if (!found) recommendation_list.push(change.doc);
                }

                set(recommendation_list)
            })

            return () => {
                changeMonitor.cancel();
            }
        })
    }

    static getStockRecommendation(recommendation_id) {
        return db.get(recommendation_id);
    }

    static createStockRecommendation(recommendation) {
        recommendation.recommendation_id = uuid();
        recommendation._id = `stockRecommendation:${recommendation.recommendation_id}`;
        recommendation.type = 'stockRecommendation';

        return db.put(recommendation);
    }

    static saveStockRecommendation(recommendation) {
        return db.put(recommendation);
    }

    static deleteStockRecommendation(recommendation) {
        recommendation._deleted = true;
        return db.put(recommendation);
    }
}